import React, { Component } from "react";
import { Modal, Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import Warning from "Assets/img/SweetAlert/warning.png";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDOM from "react-dom";
import MyGig from "../../../constants/MyGig";

const Z_INDEX = {
  MODAL: 1300,
  SWEET_ALERT: 1500
};

// CSS styles cho loading overlay
const loadingOverlayStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  borderRadius: '8px'
};

const loadingContentStyles = {
  textAlign: 'center',
  padding: '20px'
};

const loadingTextStyles = {
  marginTop: '16px',
  fontSize: '18px',
  fontWeight: 'bold',
  color: '#333'
};

const loadingSubtextStyles = {
  marginTop: '8px',
  fontSize: '14px',
  color: '#666'
};

class CancelShiftModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedShifts: [],
      loading: false,
      showConfirmAlert: false,
      selectAll: false,
    };
    
    this.loadAssignmentDetail = this.loadAssignmentDetail.bind(this);
    this.handleShiftToggle = this.handleShiftToggle.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancelShifts = this.handleCancelShifts.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.renderShiftItem = this.renderShiftItem.bind(this);
    this.renderDateGroup = this.renderDateGroup.bind(this);
  }

  componentDidMount() {
    if (this.props.isOpen && this.props.employee) {
      this.loadAssignmentDetail();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen && this.props.employee) {
      this.loadAssignmentDetail();
    }
    
    if (prevProps.loadingCancelShift && !this.props.loadingCancelShift && !this.props.errorCancelShift) {
      this.setState({ loading: false });
      
      if (this.props.onSuccess) {
        this.props.onSuccess();
      }
      
      this.props.closeModal();
    }
    
    if (prevProps.loadingCancelShift && !this.props.loadingCancelShift && this.props.errorCancelShift) {
      this.setState({ loading: false });
      console.error("Cancel shift failed:", this.props.errorCancelShift);
    }
  }

  loadAssignmentDetail() {
    const { employee, getAssignmentDetail } = this.props;
    const params = employee.job_response_id 
      ? { job_response_id: employee.job_response_id }
      : { assignment_id: employee.id };
    
    getAssignmentDetail(params);
  }

  handleShiftToggle(scheduleId) {
    const { selectedShifts } = this.state;
    const newSelectedShifts = selectedShifts.includes(scheduleId)
      ? selectedShifts.filter(id => id !== scheduleId)
      : [...selectedShifts, scheduleId];
    
    this.setState({ selectedShifts: newSelectedShifts });
  }

  handleSelectAll() {
    const { assignmentDetail } = this.props;
    const { selectAll } = this.state;
    
    if (!assignmentDetail || !assignmentDetail.schedules) return;
    
    const filteredSchedules = assignmentDetail.schedules.filter(schedule => schedule.status === MyGig.status.ASSIGNED_SCHEDULE_UNCHECKED);
    const newSelectAll = !selectAll;
    const newSelectedShifts = newSelectAll 
      ? filteredSchedules.map(schedule => schedule.id)
      : [];
    
    this.setState({ 
      selectAll: newSelectAll,
      selectedShifts: newSelectedShifts 
    });
  }

  handleConfirm() {
    const { selectedShifts } = this.state;
    if (selectedShifts.length === 0) {
      return;
    }
    this.setState({ showConfirmAlert: true });
  }

  handleCancelShifts() {
    const { selectedShifts } = this.state;
    const { employee, cancelMultipleShift } = this.props;
  
    this.setState({ loading: true });
  
    cancelMultipleShift({
      scheduleIds: selectedShifts,
      positionId: employee.position_id,
      employeeId: employee.employee_id
    });
    
    this.setState({ 
      showConfirmAlert: false,
      selectedShifts: [] 
    });
  }
  

  handleClose() {
    this.setState({ 
      selectedShifts: [],
      showConfirmAlert: false 
    });
    this.props.closeModal();
  }

  renderShiftItem(schedule) {
    const { selectedShifts } = this.state;
    const { loadingCancelShift } = this.props;
    const isSelected = selectedShifts.includes(schedule.id);
    
    const startTime = moment.unix(schedule.schedule[0].start).format("DD/MM/YYYY HH:mm");
    const endTime = moment.unix(schedule.schedule[0].end).format("HH:mm");
    
    return (
      <div 
        key={schedule.id} 
        className={`shift-item ${isSelected ? 'selected' : ''} ${loadingCancelShift ? 'disabled' : ''}`}
        onClick={() => !loadingCancelShift && this.handleShiftToggle(schedule.id)}
      >
        <div className="shift-checkbox">
          <input 
            type="checkbox" 
            checked={isSelected}
            onChange={() => !loadingCancelShift && this.handleShiftToggle(schedule.id)}
            disabled={loadingCancelShift}
            className="shift-checkbox-input"
          />
        </div>
        <div className="shift-info">
          <div className="shift-date">{startTime} - {endTime}</div>
          <div className="shift-id">ID: {schedule.id}</div>
        </div>
      </div>
    );
  }

  renderDateGroup(dateKey, shifts) {
    const dateHeader = moment(dateKey, "YYYY-MM-DD").format("dddd, DD/MM/YYYY");
    
    return (
      <div key={dateKey} className="date-group">
        <div className="date-header">{dateHeader}</div>
        <div className="shifts-list">
          {shifts.map(this.renderShiftItem)}
        </div>
      </div>
    );
  }

  render() {
    const { isOpen, employee, assignmentDetail, loading, loadingCancelShift } = this.props;
    const { selectedShifts, showConfirmAlert, selectAll } = this.state;
    
    if (!employee) return null;

    const hasShifts = assignmentDetail && assignmentDetail.schedules && assignmentDetail.schedules.length > 0;
    const filteredSchedules = hasShifts ? assignmentDetail.schedules.filter(schedule => schedule.status === MyGig.status.ASSIGNED_SCHEDULE_UNCHECKED) : [];
    const allSelected = filteredSchedules.length > 0 && selectedShifts.length === filteredSchedules.length;
    
    const isModalDisabled = loadingCancelShift;

    let groupedShifts = {};
    if (filteredSchedules.length > 0) {
      filteredSchedules.forEach(schedule => {
        const dateKey = moment.unix(schedule.schedule[0].start).format("YYYY-MM-DD");
        if (!groupedShifts[dateKey]) {
          groupedShifts[dateKey] = [];
        }
        groupedShifts[dateKey].push(schedule);
      });
      
      const sortedDates = Object.keys(groupedShifts).sort();
      groupedShifts = sortedDates.reduce((obj, key) => {
        obj[key] = groupedShifts[key];
        return obj;
      }, {});
    }

    return (
      <React.Fragment>
        <Modal 
          open={isOpen} 
          onClose={this.handleClose}
          className="cancel-shift-modal"
          style={{ zIndex: Z_INDEX.MODAL }}
          disableBackdropClick={isModalDisabled}
          disableEscapeKeyDown={isModalDisabled}
        >
          <div className="modal-content" style={{ position: 'relative' }}>
            {/* Loading overlay khi đang cancel shifts */}
            {isModalDisabled && (
              <div style={loadingOverlayStyles}>
                <div style={loadingContentStyles}>
                  <CircularProgress size={60} className="loading-spinner" />
                  <div style={loadingTextStyles}>
                    <FormattedMessage id="modal.cancelShift.cancelling" defaultMessage="Cancelling shifts..." />
                  </div>
                  <div style={loadingSubtextStyles}>
                    Please wait while we process your request...
                  </div>
                </div>
              </div>
            )}
            <div className="modal-header">
              <div className="modal-header-content">
                <div className="modal-title">
                  <FormattedMessage 
                    id="modal.cancelShift.title" 
                    values={{ employeeName: employee.user_fullname }}
                  />
                </div>
                <div className="modal-instruction">
                  <FormattedMessage id="modal.cancelShift.instruction" />
                </div>
              </div>
            </div>
            
            <div className="modal-body">
              {filteredSchedules.length > 0 && (
                <div className="select-all-section">
                  <span className="select-all-label">
                    <input 
                      type="checkbox" 
                      checked={allSelected}
                      onChange={this.handleSelectAll}
                      disabled={isModalDisabled}
                      className="select-all-checkbox"
                    />
                    <span className="select-all-text">
                      <FormattedMessage 
                        id="modal.cancelShift.selectAll" 
                        values={{ count: filteredSchedules.length }}
                      />
                    </span>
                  </span>
                </div>
              )}

              <div className="shifts-section">
                {loading ? (
                  <div className="loading-container">
                    <CircularProgress size={40} className="loading-spinner" />
                    <div className="loading-text">
                      <FormattedMessage id="common.loading" />
                    </div>
                  </div>
                ) : filteredSchedules.length > 0 ? (
                  Object.entries(groupedShifts).map(([dateKey, shifts]) => 
                    this.renderDateGroup(dateKey, shifts)
                  )
                ) : (
                  <div className="empty-state">
                    <i className="material-icons empty-icon">schedule</i>
                    <div className="empty-text">
                      <FormattedMessage id="modal.cancelShift.noShifts" />
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            <div className="modal-footer">
              <div className="footer-content">
                <Button 
                  variant="contained" 
                  color="default" 
                  onClick={this.handleClose} 
                  disabled={isModalDisabled}
                  className="btn-cancel"
                >
                  <FormattedMessage id="button.cancel" />
                </Button>
                <Button 
                  variant="contained"
                  color="secondary" 
                  onClick={this.handleConfirm}
                  disabled={selectedShifts.length === 0 || isModalDisabled}
                  className="btn-confirm"
                >
                  <FormattedMessage 
                    id="common.button.confirm" 
                    values={{ count: selectedShifts.length }}
                  />
                </Button>
              </div>
            </div>
          </div>
        </Modal>

        {showConfirmAlert && ReactDOM.createPortal(
          <SweetAlert
            custom
            customIcon={Warning}
            showCancel
            title={<FormattedMessage id="modal.cancelShift.confirmTitle" />}
            onConfirm={this.handleCancelShifts}
            onCancel={() => this.setState({ showConfirmAlert: false })}
            confirmBtnCssClass="btn-danger"
            cancelBtnCssClass="btn-secondary"
            confirmBtnText="Confirm"
            cancelBtnText="Cancel"
            style={{ zIndex: 13000000 }}
            disabled={isModalDisabled}
          >
            {employee && selectedShifts.length > 0 ? (
              `Are you sure you want to cancel ${selectedShifts.length} shift(s) for ${employee.user_fullname}?`
            ) : (
              'Are you sure you want to cancel the selected shifts?'
            )}
          </SweetAlert>,
          document.body
        )}
      </React.Fragment>
    );
  }
}

export default CancelShiftModal;
